/* eslint-disable */

import BasicService from "../../lib/api/CRUD/BasicService";

export default class Home extends BasicService {

    constructor(store) {

        //Nome do model

        super('indicadores');

    }

    async getIndicadores(){
        return super.postWithPath('filter').then(
            response => {            
                return Promise.resolve(response);
            },
            error => {
                return Promise.reject(error);
            },
        );
    }

}